exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.data-export-dates[data-v-1ae0bf30] {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 0.75rem 1.5rem;\n}\n.data-export-date[data-v-1ae0bf30] {\n    width: 200px;\n    flex: 0 0 200px;\n}\n", ""]);

// exports
